<script>
	import ProductModule from '@/enums/productModule';
	import ProductPlanBillingCycle from '@/enums/productPlanBillingCycle';
	import ProductPlanDetailsTitleAndPrice from '@components/settings/billing/ProductPlanDetailsTitleAndPrice.vue';

	export default {
		name: 'ProductPlanDetails',
		components: { ProductPlanDetailsTitleAndPrice },
		props: {
			productPlan: {
				type: Object,
				required: true
			},
			hideSelect: {
				type: Boolean,
				default: false
			},
			yearly: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			pricingOption() {
				if (this.yearly) {
					const annual = this.productPlan.pricingOptions.find(x => x.billingCycle === ProductPlanBillingCycle.Annual)
					if (annual) return annual
				}
				return this.productPlan.pricingOptions.find(x => x.billingCycle === ProductPlanBillingCycle.Monthly)
			}
		},
		methods: {
			getModuleDescription(module) {
				switch (module) {
					case ProductModule.AssetRegister: return "Asset Register"
					case ProductModule.CheckIns: return "Check Ins"
					case ProductModule.Goals: return "Goals"
					case ProductModule.OrgChart: return "Company Organisation Chart"
					case ProductModule.Compliance: return "Compliance Documents"
					case ProductModule.PerformanceReviews: return "Performance Reviews"
					case ProductModule.PositionDescriptions: return "Position Descriptions"
				}
			},
			getPlanCycleTime(billingCycle) {
				switch (billingCycle) {
					case ProductPlanBillingCycle.Monthly: return "month"
					case ProductPlanBillingCycle.Annual: return "year"
				}
			}
		}
	};
</script>

<template>
	<v-card class="card" :class="{ 'is-highlighted': productPlan.isHighlighted && !hideSelect }">
		<v-card-title primary-title>
			<div style="position: absolute; top: 0; right: 0;" v-if="!hideSelect">
				<v-chip v-if="productPlan.isHighlighted" color="info" outline dark small>Most Popular</v-chip>
				<v-chip v-else-if="productPlan.isExclusive" color="success" outline dark small>Exclusive Plan</v-chip>
			</div>
			<ProductPlanDetailsTitleAndPrice :product-plan="productPlan" :pricing-option-id="pricingOption.id" class="mt-3"/>
			<div v-if="!hideSelect" class="select-plan-container">
				<v-btn class="primary" @click="$emit('select', {planId: productPlan.id, pricingId: pricingOption.id})">Select Plan</v-btn>
			</div>
		</v-card-title>
		<v-card-text class="text-xs-left">
			

			<div class="feature-list" v-if="productPlan.modules.length > 0">
				<v-divider class="mb-3" />
				<h4>Included Features</h4>
				<div v-for="module in productPlan.modules" class="feature-item">
					<v-icon color="green">mdi-check-circle-outline</v-icon> {{getModuleDescription(module)}}
				</div>
			</div>
		</v-card-text>
		<v-card-actions >
			
		</v-card-actions>
	</v-card>
</template>

<style scoped>

	.full {
		width: 100%;
		text-align: left;
	}

	.feature-list {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	.feature-item {
		display: flex;
		align-items: center;
		gap: 0.5rem;
	}

	.select-plan-container {
		flex: auto;
		margin-top:1rem;
	}
	.is-highlighted {
		background-color: #f4f7fe;
	}
</style>